import { format, parseISO, eachDayOfInterval } from 'date-fns';

export const MAX_TRIP_DAYS = 60;

// overnight: null until the user answers (new trips); booleans for saved days
export const emptyDay = (date) => ({
  date,
  departure_time: '',
  end_time: '',
  breakfast_covered: false,
  lunch_covered: false,
  dinner_covered: false,
  overnight: null,
});

/** Every date from start to end inclusive ('yyyy-MM-dd'), capped at MAX_TRIP_DAYS. */
export function daysBetween(start, end) {
  if (!start || !end || end < start) return [];
  return eachDayOfInterval({ start: parseISO(start), end: parseISO(end) })
    .slice(0, MAX_TRIP_DAYS)
    .map(d => format(d, 'yyyy-MM-dd'));
}

/** Day list for new dates, keeping what was entered for dates that remain. */
export function rebuildDays(days, start, end) {
  const byDate = Object.fromEntries(days.map(d => [d.date, d]));
  return daysBetween(start, end).map(date => byDate[date] || emptyDay(date));
}

/** Nights still missing a Yes/No answer (the last day has no night). */
export function unansweredNights(days) {
  return days.slice(0, -1).filter(d => d.overnight === null).length;
}

/** API payload for create/update from the wizard's form state. */
export function buildTripPayload(form) {
  return {
    name: form.name.trim(),
    is_foreign_travel: form.is_foreign_travel,
    border_crossing_outbound: form.is_foreign_travel ? form.border_crossing_outbound || null : null,
    border_crossing_return: form.is_foreign_travel ? form.border_crossing_return || null : null,
    seminar_includes_meals: form.seminar_includes_meals,
    notes: form.notes || null,
    days: form.days.map((d, i) => ({
      date: new Date(d.date).toISOString(),
      departure_time: d.departure_time || null,
      end_time: d.end_time || null,
      breakfast_covered: d.breakfast_covered,
      lunch_covered: d.lunch_covered,
      dinner_covered: d.dinner_covered,
      // No night after the last day
      overnight: i < form.days.length - 1 ? Boolean(d.overnight) : false,
    })),
    destinations: form.destinations
      .filter(d => d.client_id)
      .map(d => ({
        client_id: parseInt(d.client_id, 10),
        location_id: d.location_id ? parseInt(d.location_id, 10) : null,
      })),
  };
}
